import { render, staticRenderFns } from "./LoadingReview.vue?vue&type=template&id=110f05d0&scoped=true&"
import script from "./LoadingReview.vue?vue&type=script&lang=js&"
export * from "./LoadingReview.vue?vue&type=script&lang=js&"
import style0 from "./LoadingReview.vue?vue&type=style&index=0&id=110f05d0&scoped=true&lang=less&"
import style1 from "./LoadingReview.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110f05d0",
  null
  
)

export default component.exports